import { api } from './api';

export interface SystemSetting {
  key: string;
  value: string;
}

export const settingsService = {
  async getTimezone(): Promise<string> {
    const s: SystemSetting = await api.get('/system-settings/timezone');
    return s.value;
  },

  async updateTimezone(tz: string): Promise<SystemSetting> {
    return api.put('/system-settings/timezone', { value: tz });
  },
};
